'use client'

import { useEffect } from 'react'
import posthog from 'posthog-js'
import { usePathname, useSearchParams } from 'next/navigation'

/**
 * manually initialises Posthog
 */
export function useAnalytics(analyticsKey?: string): void {
  const pathname = usePathname()
  const searchParams = useSearchParams()

  const handleRouteChange = () => posthog.capture('$pageview')

  useEffect(() => {
    if (
      process.env['NEXT_PUBLIC_POSTHOG_DEBUG'] &&
      window.location.hostname.includes('localhost')
    ) {
      posthog.debug(true)
    }
  }, [])

  useEffect(() => {
    if (!analyticsKey) return

    // Init PostHog
    posthog.init(analyticsKey, {
      api_host: 'https://app.posthog.com',
    })

    // Track page views
    handleRouteChange()
  }, [pathname, searchParams])
}
